import React from 'react'

export interface IconMinusProps extends React.SVGProps<SVGSVGElement> {
  color?: string
}

function _IconMinus(
  { color = 'currentColor', ...props }: IconMinusProps,
  ref?: React.Ref<SVGSVGElement>,
) {
  return (
    <svg
      width="12"
      height="2"
      viewBox="0 0 12 2"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 1C0 0.585786 0.335786 0.25 0.75 0.25H11.25C11.6642 0.25 12 0.585786 12 1C12 1.41421 11.6642 1.75 11.25 1.75H0.75C0.335786 1.75 0 1.41421 0 1Z"
        fill={color}
      />
    </svg>
  )
}

const IconMinus = React.memo(React.forwardRef(_IconMinus))

export { IconMinus }
